import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ className, percentage, text }) => {
  return (
    <div className={className} data-testid="progress-bar">
      <div className="progress-bar">
        <div className="progress-bar__background">
          <div className="progress-bar__progress"></div>
        </div>
        <div className="progress-bar__label">{`${percentage}% ${text}`}</div>
      </div>
    </div>
  );
};
ProgressBar.propTypes = {
  className: PropTypes.string,
  percentage: PropTypes.number,
  text: PropTypes.string
};
export default ProgressBar;
